import { render, staticRenderFns } from "./productPricingBulkEditor.vue?vue&type=template&id=61a64488&scoped=true&"
import script from "./productPricingBulkEditor.vue?vue&type=script&lang=js&"
export * from "./productPricingBulkEditor.vue?vue&type=script&lang=js&"
import style0 from "./productPricingBulkEditor.vue?vue&type=style&index=0&id=61a64488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a64488",
  null
  
)

export default component.exports